// extracted by mini-css-extract-plugin
module.exports = {"timelineGrid":"style__timelineGrid___1XuQ8","timeline":"style__timeline___Oqh0o","recipient":"style__recipient___21Ld8","stateDate":"style__stateDate___BVdE3"};